import React from 'react';
import { Box, Text, Flex } from '@fullstory/components';
import { CHART_TOP_PADDING } from './const';
import { FormattedMessage } from 'react-intl';

interface PageFlowHeaderProps {
  name: string;
  visits: number;
  visitsPct?: string;
}

export const PageFlowHeader: React.FC<PageFlowHeaderProps> = ({ name, visits, visitsPct }) => (
  <Box data-component="PageFlowHeader" marginLeft={12} paddingTop={CHART_TOP_PADDING}>
    <Box>
      <Text appearance="bodyMediumBold" color="default" className="fs-unmask">
        {name}
      </Text>
      <Flex justifyContent="flex-start">
        {visitsPct && (
          <>
            <Text appearance="bodyMediumBold" color="default">
              {visitsPct}
            </Text>
            <Box margin={[0, 4, 0, 4]}>
              <Text appearance="bodySmall" color="default">
                <FormattedMessage
                  defaultMessage="·"
                  id="G7uas+"
                  description="Used as a separator e.g 10% · 100 views"
                />
              </Text>
            </Box>
          </>
        )}
        <Text appearance="bodySmall" color="default">
          <FormattedMessage
            defaultMessage="{visits, number, ::compact-short} Pageviews"
            id="8naCcI"
            values={{ visits }}
          />
        </Text>
      </Flex>
    </Box>
  </Box>
);
